(() => {
  const faqSections = document.querySelectorAll("[data-onura-faq]");

  if (!faqSections.length) return;

  faqSections.forEach((section) => {
    const toggles = section.querySelectorAll("[data-onura-faq-toggle]");

    toggles.forEach((toggle) => {
      const panelId = toggle.getAttribute("aria-controls");
      const panel = panelId ? document.getElementById(panelId) : null;

      if (!panel) return;

      toggle.addEventListener("click", () => {
        const isOpen = toggle.getAttribute("aria-expanded") === "true";

        toggle.setAttribute("aria-expanded", String(!isOpen));
        panel.classList.toggle("is-open", !isOpen);

        if (isOpen) {
          panel.setAttribute("hidden", "");
        } else {
          panel.removeAttribute("hidden");
        }
      });
    });
  });
})();